<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-4">
      <search-form :fields="search" />
      <button-link v-if="hasPermsCreate" :to="`warehouses/create`">添加</button-link>
    </el-button-group>

    <el-table :data="warehouses" resource="warehouses">
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="code" label="仓库编码" />
      <el-table-column prop="name" label="仓库名称" />
      <el-table-column prop="area" label="仓库省市地区" width="200"  />
      <el-table-column prop="address" label="所在地址" />
      <el-table-column prop="mobile" label="联系方式" />
      <el-table-column prop="username" label="负责人员" />
      <el-table-column prop="is_default" label="默认仓库">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_default" type="success">是</el-tag>
          <el-tag v-else type="warning" disable-transitions>否</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="小票打印机">
        <template slot-scope="scope">
          <span v-if="scope.row.printer">
            {{scope.row.printer.name}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="添加时间" width="170" />
      <el-table-column prop="updated_at" label="更新时间" width="170" />
      <el-table-column label="操作" width="140">
        <template #default="{ row, $index }">
          <el-button-group>
            <row-to-edit v-if="hasPermsEdit" />
            <row-destroy v-if="hasPermsDelete && row.is_default != 1" />
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import { getWarehouses } from '@/api/warehouses'
import { can } from '@/libs/utils'
import ButtonLink from '@c/ButtonLink'
import RowDestroy from '@c/LzTable/RowDestroy'
import RowToEdit from '@c/LzTable/RowToEdit'
import Pagination from '@c/Pagination'
import SearchForm from '@c/SearchForm'

export default {
  name: 'Index',
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination,
    ButtonLink,
  },
  data() {
    return {
      search: [
        {
          field: 'code',
          label: '仓库编码',
        },
        {
          field: 'name',
          label: '仓库名称',
        },
        {
          field: 'mobile',
          label: '联系方式',
        },
        {
          field: 'username',
          label: '负责人员',
        },
      ],
      warehouses: [],
      page: null,
      hasPermsDelete: false,
      hasPermsCreate: false,
      hasPermsEdit: false,
    }
  },
  methods: {},
  watch: {
    $route: {
      async handler(newVal) {
        const {
          data: { data, meta },
        } = await getWarehouses(newVal.query)
        this.warehouses = data
        this.page = meta
      },
      immediate: true,
    },
  },
  created() {
    this.hasPermsDelete = can('warehouses.delete')
    this.hasPermsEdit = can('warehouses.edit')
    this.hasPermsCreate = can('warehouses.create')
  },
}
</script>
